<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <p class="form__heading">
            <span>{{ inputData.name }}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </p>
        <p class="form__description" :id="'description_' + inputData.id" v-if="inputData.desc" v-html="inputData.desc "></p>
        <div class="form__input-container" v-for="inputOption in inputData.inputoptions.sort((a, b) => a.order - b.order)" :key="inputOption.id">
            <input class="form__input form__input--checkbox" :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                type="checkbox" 
                :name="'input_' + inputOption.id" 
                :id="'inputField_' + inputOption.id"
                :value="inputOption.id"
                :required="inputData.required"
                :class="inputData.error ? 'form__input--error' : ''"
                v-model="selected"
                v-on:change="updateInputOptions">    
            <label :for="'inputField_' + inputOption.id" class="form__label form__label--checkbox">{{ inputOption.text }}</label>
        </div>
        <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
    </div>
</template>

<script>
import RequiredIndicator from './RequiredIndicator.vue';

export default {
    props: ['inputData', 'selectedOptions'],
    emits: ['inputOptions'],
    components: {
        'required-indicator': RequiredIndicator
    },
    data() {
        return{
            selected: [],
            options: [],
        }
    },
    methods: {
        updateInputOptions(){
            this.$emit('inputOptions', this.options, this.selected);
        },
        updateOptions(){
            this.options = [];
            this.inputData.inputoptions.forEach((inputOption) => {
                this.options.push(inputOption.id);
            });
        }
    },
    mounted(){
        this.updateOptions();
    },
    watch: {
        inputData(){
            this.updateOptions();
        },
        selectedOptions(newVal, oldVal) {
            const selectedIds = newVal.map(i => i.id);
            for (const id of selectedIds) {
                if (!id || !this.options.includes(id) || this.selected.includes(id)) {
                    continue;
                }

                this.selected.push(id);
            }
        }
    }
}
</script>